import ValueDiscoveryFramework from '../_components/ValueDiscoveryFramework'
import { Account } from "@/types";
import { Card, CardContent, CardHeader } from "@/components/ui/card.tsx";


interface DetailsTabProps {
    valueDiscoveryFrameworks?: NonNullable<Account['valueDiscoveryFramework']>
}

export default function DetailsTab({valueDiscoveryFrameworks}: DetailsTabProps) {
    return (
        <Card>
            <CardHeader>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-neutral-50">
                    Product Offering and Value Creation Logic
                </h3>
            </CardHeader>
            <CardContent>
                <p className="text-slate-600 dark:text-neutral-300 mb-2">
                    Illustrates the relationship between use cases, functions, and their value metrics.
                </p>
                <ValueDiscoveryFramework valueDiscoveryFrameworks={valueDiscoveryFrameworks}/>
            </CardContent>

        </Card>
    )
}